// Shared across login and authenticated routes; initialized once at application startup.
export const THEME_STORAGE_KEY = 'crec-color-mode';
const modes = ['light', 'dark', 'system'];
let preference = 'system';
let media = null;
let initialized = false;
const subscribers = [];
function normalize(value) { return modes.indexOf(value) >= 0 ? value : 'system'; }
function applyTheme() {
    const resolved = preference === 'system' ? (media && media.matches ? 'dark' : 'light') : preference;
    document.documentElement.setAttribute('data-theme', resolved);
    document.documentElement.style.colorScheme = resolved;
    subscribers.slice().forEach(listener => listener(preference));
}
export function initTheme() {
    if (initialized) return;
    initialized = true;
    try { preference = normalize(window.localStorage.getItem(THEME_STORAGE_KEY)); } catch (_) { preference = 'system'; }
    media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
    if (media) {
        if (media.addEventListener) media.addEventListener('change', applyTheme);
        else if (media.addListener) media.addListener(applyTheme);
    }
    window.addEventListener('storage', event => {
        if (event.key === THEME_STORAGE_KEY || event.key === null) {
            preference = normalize(event.newValue);
            applyTheme();
        }
    });
    applyTheme();
}
export function getThemePreference() { return preference; }
export function setThemePreference(value) {
    preference = normalize(value);
    try { window.localStorage.setItem(THEME_STORAGE_KEY, preference); } catch (_) { /* Session-only selection when storage is unavailable. */ }
    applyTheme();
}
export function subscribeTheme(listener) {
    subscribers.push(listener);
    return () => {
        const index = subscribers.indexOf(listener);
        if (index >= 0) subscribers.splice(index, 1);
    };
}



// WEBPACK FOOTER //
// ./src/utils/theme.js